import {
    Button,
    Card,
    CardContent,
    Stack,
    Typography
} from "@mui/material"
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import RocketTwoToneIcon from '@mui/icons-material/RocketTwoTone';
import PrintIcon from '@mui/icons-material/Print';

import { Datagrid, DateField, FunctionField, List, TextField, TextInput, useDataProvider, useListContext, useNotify } from "react-admin";
import { useEffect, useState } from "react";
import { zLabel } from "./components/ZLabel";

export const BulkOrderList = () => {
    const [printer, setPrinter] = useState()
    const dataProvider = useDataProvider()
    const [releaseDates, setReleaseDates] = useState([])
    const notify = useNotify()

    const Filters = [
        <TextInput label='List' source='list.name' />,
        <TextInput label='School' source='school.name' />
    ]

    const handleDirectPrint = async (labelType, contextData) => {
        // Use passed context data
        const { data, selectedIds } = contextData
        
        // Get selected orders from context data
        const orders = data ? selectedIds.map(id => data.find(item => item.id === id)).filter(Boolean) : []
        
        if (orders.length === 0) {
            notify('No orders selected', { type: 'warning' })
            return
        }

        // Execute print logic directly for box labels using legacy printer only
        if (printer) {
            try {
                let printData = ''
                orders.forEach(order => {
                    printData += zLabel(order, releaseDates)
                })
                printer.send(printData)
                notify('Box labels printed successfully via legacy printer', { type: 'success' })
            } catch(e) {
                console.error("Legacy printer error:", e)
                notify('Unable to print! Printer not responding', { type: 'error' })
            }
        } else {
            notify('No printer configured for box labels', { type: 'error' })
        }
    }



    const Actions = () => {
        // Get context data inside the Actions component
        const { data, selectedIds } = useListContext()
        
        return (
            <Button
                variant='outlined'
                onClick={() => handleDirectPrint('box', { data, selectedIds })}
                startIcon={<PrintIcon />}
            >
                Print Box Labels
            </Button>
        )
    }



    useEffect(() => {
        const settings = JSON.parse(localStorage.getItem('zWarehouse'))
        const { printers } = settings
        const { printer } = window.devices

        dataProvider.getConstants()
            .then(({ data }) => {
                const dates = data.filter(constant => {
                    const item = Object.keys(constant)[0]
                    return item.startsWith('release_date')
                })

                setReleaseDates(dates)
            })

        // Box Label Printer only
        if (printer) {
            setPrinter(printer.find(p => p.uid === printers['box']?.uid))
        }
    }, [dataProvider])

    return (
        <Card>
            <CardContent>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <LocalShippingTwoToneIcon sx={{ fontSize: 46 }} color="primary" />
                    <Typography variant='h4' color='primary'>
                        Bulk Orders 'On Deck'
                    </Typography>
                    <RocketTwoToneIcon color='secondary' />
                </Stack>

                <List filters={Filters}>
                    <>
                        <Datagrid bulkActionButtons={<Actions />}>
                            <FunctionField label='ID' render={record => 
                                `B-${record.id}`} />
                            <TextField source='date' label='Order Date' />
                            <TextField source='list.name' label='List' />
                            <TextField source='school.name' label='School' />
                            <DateField source='release_date' label='Release Date' />
                        </Datagrid>
                    </>
                </List>
            </CardContent>
        </Card>
    )
}